module.exports = __webpack_public_path__ + "dinner-table.7be26c19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/retailers/dinner-table.png
// module id = 1739
// module chunks = 0